const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const toMinutes = (timeStr) => {
  const [h, m] = timeStr.split(":").map(Number);
  return h * 60 + m;
};

function setPostcodeSuburbAsCartAttribute({ postcode, suburb }) {
  const postcodeHiddenInput = document.querySelector('#pre-filled-postcode');
  const suburbHiddenInput = document.querySelector('#pre-filled-suburb');
  postcodeHiddenInput.value = postcode;
  suburbHiddenInput.value = suburb;
  console.log('cdebug setpost', postcode, postcodeHiddenInput, postcodeHiddenInput.value)
}

function getFormattedTimes(schedule) {
  function formatToAmPm(time24h) {
    const [hour, minute] = time24h.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
  }

  return {
    timeStartAP: formatToAmPm(schedule.timeStart),
    timeEndAP: formatToAmPm(schedule.timeEnd)
  };
}

function sortByWeekdayId(scheduleArray) {
  return scheduleArray.slice().sort((a, b) => {
    return parseInt(a.weekdayId) - parseInt(b.weekdayId);
  });
}

function addLastDeliveryDay(incomingShippingWindows) {
  let newShippingWindows = [];

  newShippingWindows = incomingShippingWindows.map(window => {
    const deliveryIndex = weekdays.indexOf(window.weekdayTitle);
    const orderCutoffIndex = (deliveryIndex + +window.orderOffset + 7) % 7;

    return {
      ...window,
      orderCutoffDay: weekdays[orderCutoffIndex]
    }
  });

  return newShippingWindows
}

function reorderByCutoffAndWeekday(schedule, todayStr = "Thursday") {
    // Helper to calculate forward weekday difference
    const daysUntil = (from, to) => (weekdays.indexOf(to) - weekdays.indexOf(from) + 7) % 7;

    // Step 1: Filter by orderCutoffDay === today
    const cutoffMatches = schedule.filter(item => item.orderCutoffDay === todayStr);

    // Step 2: Group cutoffMatches by weekdayTitle
    const cutoffGrouped = cutoffMatches.reduce((acc, item) => {
        if (!acc[item.weekdayTitle]) acc[item.weekdayTitle] = [];
        acc[item.weekdayTitle].push(item);
        return acc;
    }, {});

    // Step 3: Sort group keys (weekdayTitles) by closest future day from today
    const sortedCutoffKeys = Object.keys(cutoffGrouped).sort(
        (a, b) => daysUntil(todayStr, a) - daysUntil(todayStr, b)
    );

    // Step 4: Flatten sorted groups into a single array
    const sortedCutoffArray = sortedCutoffKeys.flatMap(key => cutoffGrouped[key]);

    // Step 5: Get remaining items (not in cutoff matches)
    const cutoffSet = new Set(sortedCutoffArray);
    const rest = schedule.filter(item => !cutoffSet.has(item));

    // Step 6: Determine the weekday after the last used cutoffMatch
    const lastUsedDay = sortedCutoffKeys[sortedCutoffKeys.length - 1] || todayStr;

    // Step 7: Sort rest based on weekday order starting from lastUsedDay
    const sortedRest = [...rest].sort((a, b) => {
        const aIndex = (weekdays.indexOf(a.weekdayTitle) - weekdays.indexOf(lastUsedDay) + 7) % 7;
        const bIndex = (weekdays.indexOf(b.weekdayTitle) - weekdays.indexOf(lastUsedDay) + 7) % 7;
        return aIndex - bIndex;
    });

    // Final result: sorted cutoff matches + sorted rest
    return [...sortedCutoffArray, ...sortedRest];
}

function checkIfBefore8pm(now) {
  const currentTime = toMinutes(now.toTimeString().slice(0, 5));
  return currentTime < toMinutes("20:00");
}

function getFirstPrimaryShippingWindows(data, now = new Date()) {
  const currentWeekdayIndex = (now.getDay() + 6) % 7; // JS: Sunday=0 → convert to Monday=0
  const currentTime = toMinutes(now.toTimeString().slice(0, 5));
  const isBefore8pm = currentTime < toMinutes("20:00");

  // Helper: get how many days ahead a given weekdayTitle is from today
  const getDaysAhead = (weekdayTitle) => {
      const targetIndex = weekdays.indexOf(weekdayTitle);
      return (targetIndex - currentWeekdayIndex + 7) % 7;
  };

  // Sort data by how far its weekday is from today
  const sortedData = [...data].sort(
      (a, b) => getDaysAhead(a.weekdayTitle) - getDaysAhead(b.weekdayTitle)
  );

  // First pass: find the nearest future weekday (incl. today)
  let firstMatchWeekday = null;
  for (let item of sortedData) {
      const diff = getDaysAhead(item.weekdayTitle);
      if (diff >= 0) {
          firstMatchWeekday = item.weekdayTitle;
          break;
      }
  }

  // If after 8PM, get the next weekday after that one
  if (!isBefore8pm && firstMatchWeekday) {
      const currentIndex = weekdays.indexOf(firstMatchWeekday);
      for (let i = 1; i <= 7; i++) {
          const nextWeekday = weekdays[(currentIndex + i) % 7];
          const nextAvailable = sortedData.find(item => item.weekdayTitle === nextWeekday);
          if (nextAvailable) {
              firstMatchWeekday = nextWeekday;
              break;
          }
      }
  }

  // Return all objects for that weekday
  return data.filter(item => item.weekdayTitle === firstMatchWeekday);
}

function getNextOrderCutoffDay(data, now = new Date()) {

  // Normalize current weekday
  const currentDay = weekdays[now.getDay() === 0 ? 6 : now.getDay() - 1]; // JS Sunday=0 → Sunday=6

  // Get unique orderCutoffDays from the data
  const uniqueCutoffDays = [...new Set(data.map(item => item.orderCutoffDay))];

  // Find the closest future cutoff day
  const getDaysAhead = (day) => {
      const targetIndex = weekdays.indexOf(day);
      const currentIndex = weekdays.indexOf(currentDay);
      return (targetIndex - currentIndex + 7) % 7;
  };

  const sortedCutoffDays = uniqueCutoffDays
      .map(day => ({ day, diff: getDaysAhead(day) }))
      .sort((a, b) => a.diff - b.diff);

  const nextCutoffDay = sortedCutoffDays[0]?.day;

  // Return all objects matching that cutoff day
  return data.filter(item => item.orderCutoffDay === nextCutoffDay);
}

// Test cases (kindly update the function dates to simulate various scenarios)
// Today before 8pm:
// findFirstDeliveryWindow("2025-04-10T15:30:00", "SYD METRO");
// Today after 8pm:
// findFirstDeliveryWindow("2025-04-10T20:30:00", "SYD METRO");
// Tomorrow before 8pm:
// findFirstDeliveryWindow("2025-04-11T15:30:00", "SYD METRO");
// Tomorrow after 8pm:
// findFirstDeliveryWindow("2025-04-11T20:30:00", "SYD METRO");
// Sunday before 8pm:
// findFirstDeliveryWindow("2025-04-13T15:30:00", "SYD METRO");
// Sunday after 8pm:
// findFirstDeliveryWindow("2025-04-13T20:30:00", "SYD METRO");
function findFirstDeliveryWindow(inputDateTime, shippingZone) {
  const inputDate = new Date(inputDateTime);
  const inputDayIndex = inputDate.getDay(); // 0 = Sunday
  const inputTime = inputDate.toTimeString().slice(0, 5); // Get time in HH:MM
  const isBefore8pm = checkIfBefore8pm(inputDate)

  // Normalize input day to match weekday array (0 = Monday)
  let initialInputWeekday = weekdays[(inputDayIndex + 6) % 7];
  let inputWeekday = initialInputWeekday;

  console.log('cdebug initial cutoff day', inputWeekday);

  // Step 1: Filter all results from the shippingZone
  const filteredShippingWindows = window?.shippingWindows ? shippingWindows.filter(
    window => window.shippingZoneTitle === shippingZone
  ) : [];

  console.log('cdebug filteredShippingWindows', filteredShippingWindows);

  // Step 2: Check first if the day today has any cutoff on the filtered shipping windows. If there is no cutoff day, find the nearest one in the future.
  const nearestValidCutoffDays = getNextOrderCutoffDay(filteredShippingWindows,inputDate);

  if(Array.isArray(nearestValidCutoffDays) && nearestValidCutoffDays.length > 0) {
    inputWeekday = nearestValidCutoffDays[0]?.orderCutoffDay;
  } else {
    return null;
  }

  console.log('cdebug final cut off day', inputWeekday);

  // Step 3: Sort the cutoff where the nearest day from today is the first and sort the rest of the items after the nearest day
  const filteredSortedShippingWindows = reorderByCutoffAndWeekday(filteredShippingWindows, inputWeekday);

  console.log('filteredSortedShippingWindows', filteredSortedShippingWindows);

  // Step 4: Look for delivery days which cut off is today
  let primaryShippingWindows = filteredSortedShippingWindows.filter((window) => {
    return window.orderCutoffDay === inputWeekday
  });
  console.log('primaryShippingWindows', primaryShippingWindows);

  // Step 5: Check first if there are multiple days in the primary shipping windows
  let primaryShippingWindowDays = primaryShippingWindows.map((v) => v.weekdayTitle).filter((item, index, self) => 
    self.indexOf(item) === index
  );

  // Step 5: If there are delivery days from step 5, check which day is nearest from today.
  let primaryShippingWindow = primaryShippingWindows.length > 0 ? getFirstPrimaryShippingWindows(primaryShippingWindows, inputDate) : [];


  // If the input week day remains to be the same and 
  // it is after 8pm and 
  // there is only 1 day of primary shipping windows, 
  // remove all entries in primaryShippingWindow
  // This is a special case intereceptor for those cases where 
  // TODO: Update this comment to show use cases as to why this is needed.
  if(initialInputWeekday == inputWeekday && !isBefore8pm && primaryShippingWindowDays.length == 1) {
    primaryShippingWindow = [];
  }

  console.log('primaryShippingWindow', primaryShippingWindow);

  // If there are primary shipping windows, finish this function already 
  if(primaryShippingWindow.length > 0 ) {
    return primaryShippingWindow[0]
  }


  // Step 6: If no primary shipping windows, look for the next shipping windows
  let nextShippingWindows = filteredSortedShippingWindows.filter((window) => {
    return window.orderCutoffDay != inputWeekday
  });
  console.log('nextShippingWindows', nextShippingWindows);
  

  if (nextShippingWindows.length > 0) {
    return nextShippingWindows[0]
  }

  // No matching window found
  return null;
}

function findZoneDeliveryDates(inputDateTime, shippingZone) {
  const inputDate = new Date(inputDateTime);
  const inputDayIndex = inputDate.getDay(); // 0 = Sunday

  // Normalize input day to match weekday array (0 = Monday)
  let initialInputWeekday = weekdays[(inputDayIndex + 6) % 7];
  let inputWeekday = initialInputWeekday;

  console.log('cdebug initial cutoff day', inputWeekday);

  // Step 1: Filter all results from the shippingZone
  const filteredShippingWindows = window?.shippingWindows ? shippingWindows.filter(
    window => window.shippingZoneTitle === shippingZone
  ) : [];


  return Array.isArray(filteredShippingWindows) && filteredShippingWindows.length > 0 ? filteredShippingWindows : [];

}

function isShippingZoneAvailable(zone) {
  let shippingWindows = window.shippingWindows ? window.shippingWindows.filter(v => v.shippingZoneTitle == zone) : []

  return shippingWindows.length > 0;
}

const getFromLocalstorage = (key) => {
  
}

function getFromLocalStorage(key) {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
}

const saveToLocalStorage = (key, data) => {
  window.localStorage.setItem(key, JSON.stringify(data));
}

function getDeliveryAndCutoffDates(schedule, today) {
  const daysMap = {
    "Sunday": 0,
    "Monday": 1,
    "Tuesday": 2,
    "Wednesday": 3,
    "Thursday": 4,
    "Friday": 5,
    "Saturday": 6
  };

  const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const currentDayName = today.toLocaleString('en-AU', { weekday: 'long' });

  function getNextWeekdayDate(targetDayName, inclusive = false) {
    const targetDay = daysMap[targetDayName];
    const currentDay = todayMidnight.getDay();

    let daysToAdd = targetDay - currentDay;
    if (daysToAdd < 0 || (!inclusive && daysToAdd === 0)) {
      daysToAdd += 7;
    }

    const nextDate = new Date(todayMidnight);
    nextDate.setDate(todayMidnight.getDate() + daysToAdd);
    return nextDate;
  }

  function formatToAmPm(time24h) {
    const [hour, minute] = time24h.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
  }

  const nextDeliveryDate = getNextWeekdayDate(schedule.weekdayTitle);
  const orderCutoffDate = getNextWeekdayDate(schedule.orderCutoffDay, true);

  return {
    nextDeliveryDate,
    orderCutoffDate,
    orderCutoffDateToday: currentDayName === schedule.orderCutoffDay,
    cutoffTimeAP: formatToAmPm(schedule.cutoffTime)
  };
}


function getOrdinalSuffix(n) {
  if (n >= 11 && n <= 13) return "th";
  switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
  }
}
function normalizeToLocalMidnight(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}


function formatDatePretty(date) {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
  ];


  const dayName = days[date.getDay()];
  const dayNum = date.getDate();
  const monthName = months[date.getMonth()];

  const suffix = getOrdinalSuffix(dayNum);

  return `${dayName} ${dayNum}${suffix} ${monthName}`;
}

function formatDatePrettyWithYear(date) {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
  ];


  const dayName = days[date.getDay()];
  const dayNum = date.getDate();
  const monthName = months[date.getMonth()];
  const year = date.getFullYear();

  const suffix = getOrdinalSuffix(dayNum);

  return `${dayName} ${dayNum}${suffix} ${monthName} ${year}`;
}


(function() {
  let shippingWindowLookupPageEl = document.querySelectorAll('shipping-window-lookup');
  let shippingDataZones = window.shippingDataZonesUrl;
  let shippingWindows = window.shippingDataWindowsUrl;
  
  let parse = function (url) {
    let deferred = $.Deferred();

    Papa.parse(url, {
      download: true,
      header: true,
      complete: results => deferred.resolve(results.data),
    });
  
    return deferred;
  };
  
    
  let initShippingZones = function (results) {
    window.shippingDataZones = results;
  };
  
  parse(shippingDataZones).then(initShippingZones);

  let initShippingWindows = function (results) {
    window.shippingWindows = addLastDeliveryDay(results);

    // Dispatch a custom event to notify that shipping windows have been loaded
    if(shippingWindowLookupPageEl) {
      shippingWindowLookupPageEl.forEach((el) => {
        el.onShippingWindowsLoaded(addLastDeliveryDay(results));
      })
    }
  };
  
  parse(shippingWindows).then(initShippingWindows);


})();

